export const EVENT = {
  name: "RAM in Raleigh",
  subtitle: "Ram Miriyala Live in Concert",
  date: "Saturday, May 9, 2026",
  doorsOpen: "8:00 PM",
  showStart: "9:00 PM EST",
  duration: "2 hours 45 minutes",
  venue: "Enigma Nightclub",
  address: "600 Creekside Drive, Raleigh, NC 27609",
  parking: "Free",
  capacity: "700–800",
  presentedBy: "Daaru Desi & Desi Day",
  instagram: "https://www.instagram.com/daaru_desi_events/",
  instagramHandle: "@daaru_desi_events",
  ticketUrl:
    "https://events.sulekha.com/ram-in-raleigh-ram-miriyala-live-concert_event-in_raleigh-nc_399249",
  earlyBirdDeadline: new Date("2026-04-18T23:59:59-04:00"),
  eventStart: new Date("2026-05-09T21:00:00-04:00"),
};

export const TICKETS = [
  {
    id: "ga",
    name: "General Admission",
    desc: "Full concert access with standing room",
    earlyPrice: 40,
    regularPrice: 50,
    features: [
      "Full concert access",
      "Standing room",
      "Food & drinks available for purchase",
    ],
    featured: false,
    cta: "Get Tickets",
  },
  {
    id: "vip",
    name: "VIP Standing",
    desc: "VIP standing admission to the event",
    earlyPrice: 60,
    regularPrice: 80,
    features: [
      "Everything in General Admission",
      "Front of stage standing area",
      "Priority entry",
    ],
    featured: true,
    popular: true,
    cta: "Get VIP Tickets",
  },
  {
    id: "vip-table",
    name: "VIP Table",
    desc: "VIP seating entry for 6 adults, no alcohol",
    earlyPrice: 600,
    regularPrice: 800,
    features: [
      "Reserved table for 6 people",
      "VIP seating area",
      "No alcohol included",
    ],
    featured: false,
    cta: "Reserve Table",
  },
  {
    id: "vvip-table",
    name: "VVIP Table",
    desc: "VIP table for 10 people including a liquor bottle or 2 buckets of beer",
    earlyPrice: 1200,
    regularPrice: 1500,
    features: [
      "Reserved table for 10 people",
      "Liquor bottle or 2 buckets of beer",
      "Best seats in the house",
    ],
    featured: false,
    cta: "Reserve VVIP Table",
  },
];

export const FAQS = [
  {
    q: "What time should I arrive?",
    a: "Doors open at 8:00 PM and the show starts at 9:00 PM. We recommend arriving by 8:00 PM to get settled and grab food or drinks before the show.",
  },
  {
    q: "When does early bird pricing end?",
    a: "Early bird pricing ends on April 18, 2026. After that, General Admission increases to $50, VIP Standing to $80, VIP Tables to $800, and VVIP Tables to $1,500.",
  },
  {
    q: "What do the table options include?",
    a: "VIP Tables seat 6 adults with VIP seating (no alcohol included). VVIP Tables seat 10 people and include a liquor bottle or 2 buckets of beer with the best seats in the house.",
  },
  {
    q: "Is there parking available?",
    a: "Yes, free parking is available at Enigma Nightclub, 600 Creekside Drive, Raleigh, NC 27609.",
  },
  {
    q: "Is this an all-ages event?",
    a: "This is an 18+ event. Valid ID is required at the door. No exceptions.",
  },
  {
    q: "Can I get a refund?",
    a: "All ticket sales are final. Tickets are non-refundable but may be transferable. Contact us on Instagram for special circumstances.",
  },
];

export function getTicketUrl(content) {
  return `${EVENT.ticketUrl}?utm_source=meta&utm_medium=paid&utm_campaign=ramraleigh&utm_content=${content}`;
}

export { trackEvent } from "./tracking";
